// sleeve colors, last element "reset"
const sleeves = [
    { id: 1, color: 'black', label:'Black' }, { id: 2, color: 'white', label:'White' }, 
  	{ id: 3, color: 'light-grey', label:'Light Grey' },{ id: 4, color: 'dark-grey', label:'Dark Grey' }, 
  	{ id: 5, color: 'brown', label:'Brown' }, { id: 6, color: 'purple', label:'Purple' },
	{ id: 7, color: 'blue', label:'Ocean Blue' }, { id: 8, color: 'light-blue', label:'Sky Blue' }, 
  	//{ id: 9, color: 'dark-green', label:'Dark Green' },
  	//{ id: 10, color: 'neon-green', label:'Neon Green' },  // Neon Green
  	{ id: 11, color: 'flourescent-green', label:'Light Green' }, // Flourescent Green
  	{ id: 12, color: 'pink', label:'Pink' }, 
  	{ id: 13, color: 'red', label:'Red' }, 
  	//{ id: 14, color: 'rose-red', label:'Rose Red' }, 
  	{ id: 15, color: 'orange', label:'Orange' }, { id: 16, color: 'yellow', label:'Yellow' }, 
  	{ id: 17, color: 'bright-yellow', label:'Bright Yellow' }, 
  	//{ id: 18, color: 'flourescent-yellow', label:'Flourescent Yellow' },
	{ color: 'reset', label:'Reset all' }
];

const connector_options = {
	'24 pin ATX' : {
		'wirecount' : 12,
		'presets' : [
			'black,black,orange,orange,black,dark-grey,dark-grey,black,orange,orange,black,black',
			'black,white,red,red,white,black,black,white,red,red,white,black',
			'white,white,pink,pink,white,light-blue,light-blue,white,pink,pink,white,white',
			'blue,blue,white,white,yellow,red,red,yellow,white,white,blue,blue',
			'yellow,orange,red,dark-grey,dark-grey,black,black,dark-grey,dark-grey,red,orange,yellow'
		]
	},	

		'8 pin CPU' : {
			'wirecount' : 4,
			'presets' : [
				'black,dark-grey,dark-grey,black',
				'black,red,red,black',
				'white,blue,blue,white'
				//'black,dark-grey,blue,black'
			]
			
		},
		
		'4 pin CPU' : {
			'wirecount' : 2,
			'presets' : [
				'black,red',
				'dark-grey,orange',
				'white,purple'
					]
		},
  		'12VHPWR (ATX3.0)' : {
			'wirecount' : 6,
			'presets' : [
				'black,orange,dark-grey,dark-grey,orange,black',
				'black,light-blue,dark-grey,dark-grey,light-blue,black',
				'white,light-blue,light-grey,light-grey,light-blue,white',
				'white,white,pink,pink,white,white'
			]
		},
      '12VHPWR (GPU) to 2x8pin (PSU)' : {
			'wirecount' : 6,
			'presets' : [
				'black,orange,dark-grey,dark-grey,orange,black',
				'black,light-blue,dark-grey,dark-grey,light-blue,black',
				'white,light-blue,light-grey,light-grey,light-blue,white',
				'white,white,pink,pink,white,white'
			]
		},
      '12VHPWR (GPU) to 3x8pin (PSU)' : {
			'wirecount' : 6,
			'presets' : [
				'black,orange,dark-grey,dark-grey,orange,black',
				'black,light-blue,dark-grey,dark-grey,light-blue,black',
				'white,light-blue,light-grey,light-grey,light-blue,white',
				'white,white,pink,pink,white,white'
			]
		},
  		'16 pin PCIe' : {
			'wirecount' : 8,
			'presets' : [
				'black,black,orange,dark-grey,dark-grey,orange,black,black',
				'black,light-blue,blue,dark-grey,dark-grey,blue,light-blue,black',
				'white,light-blue,light-blue,light-grey,light-grey,light-blue,light-blue,white',
				'white,pink,pink,white,white,pink,pink,white'
			]
		},
		'8 pin PCIe' : {
			'wirecount' : 4,
			'presets' : [
				'black,dark-grey,dark-grey,black',
				'black,red,red,black',
				'black,light-blue,blue,black',
				'black,white,white,black'
			]
		},
		'6 pin PCIe' : {
			'wirecount' : 3,
			'presets' : [
				'white,light-blue,white',
				//'black,dark-grey,black',
				'black,red,black',
				'blue,black,blue',
				'dark-grey,orange,dark-grey'
			]
		},
		'SATA power (Single)' : {
			'wirecount' : 5,
			'presets' : [
				'black,dark-grey,red,dark-grey,black',
				'black,red,orange,yellow,black',
				'black,blue,light-blue,blue,black',
				'dark-grey,white,black,white,dark-grey'
			]
		},
		'SATA power (Dual)' : {
			'wirecount' : 5,
			'presets' : [
				'black,dark-grey,red,dark-grey,black',
				'black,red,orange,yellow,black',
				'black,blue,light-blue,blue,black',
				'dark-grey,white,black,white,dark-grey'
			]
		},
		'SATA power (Triple)' : {
			'wirecount' : 5,
			'presets' : [
				'black,dark-grey,red,dark-grey,black',
				'black,red,orange,yellow,black',
				'black,blue,light-blue,blue,black',
				'dark-grey,white,black,white,dark-grey'
			]
		},
		'SATA power (Quad)' : {
			'wirecount' : 5,
			'presets' : [
				'black,dark-grey,red,dark-grey,black',
				'black,red,orange,yellow,black',
				'black,blue,light-blue,blue,black',
				'dark-grey,white,black,white,dark-grey'
			]
		},
		'4 pin Molex (Single)' : {
			'wirecount' : 4,
			'presets' : [
				'black,light-grey,light-grey,black',
				'black,blue,light-blue,black',
				'black,red,red,black',
				'purple,red,orange,yellow'
			]
		},
		'4 pin Molex (Dual)' : {
			'wirecount' : 4,
			'presets' : [
				'black,light-grey,light-grey,black',
				'black,blue,light-blue,black',
				'black,red,red,black',
				'purple,red,orange,yellow'
			]
		},
		'4 pin Molex (Triple)' : {
			'wirecount' : 4,
			'presets' : [
				'black,light-grey,light-grey,black',
				'black,blue,light-blue,black',
				'black,red,red,black',
				'purple,red,orange,yellow'
			]
		},
		'4 pin Molex (Quad)' : {
			'wirecount' : 4,
			'presets' : [
				'black,light-grey,light-grey,black',
				'black,blue,light-blue,black',
				'black,red,red,black',
				'purple,red,orange,yellow'
			]
		},
};